import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useNavigate } from "react-router-dom";
import { server } from "./server";
import axios from "axios";
import { toast } from "react-toastify";
const AuthContext = createContext({});
export const Authentication = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loadingInitial, setLoadingInitial] = useState(true);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(true);

  const changeMenuSize = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const verifyToken = localStorage.getItem("token");

    if (verifyToken) {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${verifyToken}`);

      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${server}/auth/profile`, requestOptions)
        .then((response) => response.text())
        .then((result) => {
          if (result) {
            setUser(JSON.parse(result).data);
            setToken(localStorage.getItem("token"));
          } else {
            setUser(null);
          }
          setLoadingInitial(false);
        })
        .catch((error) => {
          console.log("error", error);
          toast.error(error?.message || "Something went wrong!");
          setLoadingInitial(false);
        });
    } else {
      setLoadingInitial(false);
    }
  }, []);

  const loginWithEmailAndPassword = async (email, password) => {
    setLoading(true);
    try {
      const { data } = await axios.post(
        `${server}/auth/login?email=${email}&password=${password}`
      );

      setUser(data?.data);
      localStorage.setItem("token", data?.token);
      setToken(data?.token);
    } catch (e) {
      toast.error(e?.response?.data || e?.message);
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setLoading(true);
    try {
      setUser(null);
      localStorage.clear();
      navigate("/login");
      setLoading(false);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const memoValues = useMemo(
    () => ({
      user,
      loading,
      loginWithEmailAndPassword,
      logout,
      token,
      menuOpen,
      changeMenuSize,
    }),
    [user, loading, token, menuOpen]
  );
  return (
    <AuthContext.Provider value={memoValues}>
      {!loadingInitial && children}
    </AuthContext.Provider>
  );
};

export default function useAuth() {
  return useContext(AuthContext);
}
